import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-106" data-mp="1cm7nc5tu7lbz">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-107" data-mp="18jkwo88wk6gd">
        <SectionHeading eyebrow="🎁 Included free" title="5 professional bonuses — included at no extra cost" subtitle="Get these 5 bonuses today with your purchase." data-id="element-108" data-mp="18l5ohq3u1baj" />

        <div className="mt-10 flex flex-col gap-6" data-id="element-109" data-mp="20bjw54l95rdr">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl border border-navy-100 bg-white" data-id="element-110" data-mp="1w7lykybksomt">
              <img src={bonus.image} alt={`${bonus.title} mockup`} className="w-full bg-navy-50 object-cover md:hidden" width={1080} height={1080} data-id="element-111" data-mp="ktqfjehjvvqb" />

              <div className="flex flex-col gap-6 p-5 sm:p-7 md:flex-row md:items-center md:gap-8" data-id="element-112" data-mp="1eu6h2qi8g9kg">
                <img src={bonus.image} alt="" aria-hidden="true" className="hidden w-2/5 shrink-0 rounded-2xl bg-navy-50 md:block" width={1080} height={1080} data-id="element-113" data-mp="1js839kaygp05" />

                <div className="min-w-0 flex-1" data-id="element-114" data-mp="w2dq11mq4yfd">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-115" data-mp="10tvpfl93mqy8">
                    <span className="rounded-lg bg-sky-500 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-116" data-mp="10v6vxstxict1">
                      🎁 {bonus.label}
                    </span>
                    <span className="rounded-lg bg-navy-100 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-navy-700" data-id="element-117" data-mp="r1zrca70j0u0">
                      Value {bonus.value}
                    </span>
                  </div>

                  <h3 className="mt-3 font-display text-xl font-black uppercase leading-tight text-navy-800 sm:text-2xl" data-id="element-118" data-mp="2jsblmy52sqaw">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy-600 sm:text-base" data-id="element-119" data-mp="2f00m3we8z6iv">
                    {bonus.description}
                  </p>

                  {bonus.items ? <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-120" data-mp="25z2g58k90oxn">
                      {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-navy-700" data-id="element-121" data-mp="2ypazv4ufnhec">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" aria-hidden="true" data-id="element-122" data-mp="2orwsrvueg4yp" />
                          <span data-id="element-123" data-mp="1dchnm4s1e6si">{item}</span>
                        </li>)}
                    </ul> : null}

                  {bonus.footer ? <p className="mt-4 text-sm italic leading-relaxed text-navy-500" data-id="element-124" data-mp="136q3lah79fx2">
                      {bonus.footer}
                    </p> : null}
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-125" data-mp="1hy8tbzzv2otm">
          <CTAButton label="Get the system + 5 bonuses" data-id="element-126" data-mp="1lz2fooxnnvke" />
        </div>
      </div>
    </section>;
}